// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__2U38Y","shimmer":"Skeleton_shimmer__1QbDt","skeleton__line":"Skeleton_skeleton__line__23QaA"};